import segmentProps from '../../lib/segmentProps';

const props = {
    saving_value: '?@energy.saving.value',
    destination_screen: '@energy.stage.current',
    origin_screen: '@energy.stage.previous',
    switch_id: '?@entities.energySwitches.current.id',
    time_on_origin: '?@energy.stage.timeOnPreviousStage',
};

export default {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_energy_questions_progressed',
            props: {
                ...segmentProps,
                ...props,
            },
        },
    },
};
